<template>
		<image-cropper
			:options="{
				aspectRatio: false,
				showPreview: false,
				croppedHeight: false,
				croppedWidth: false,
				previewQuality: 1,
				resultQuality: 1,
				dropareaMessage: 'Choose a file or drag it here'
			}"
			@cropper-saved="saveImage"
		/>
</template>

<script>
import FileService from '@/services/FileService'
import Messages from '@/helpers/message-helper'
import ImageCropper from 'vue-anka-cropper'
import 'vue-anka-cropper/dist/VueAnkaCropper.css'

export default {
	name: 'ImageUploadResizer',

	data() {
		return {
			imageData: ''
		}
	},

	components: {
		ImageCropper
	},

	methods: {
		async saveImage(image) {
			const { croppedFile, filename } = image
			const file = new File([croppedFile], filename);

			Messages.showSaving()

			const uploadResult = await FileService.uploadS3(filename, file)
			const newfile =  { src: uploadResult.path, alt: filename }

			Messages.showSuccess('uploaded')

			this.$emit('select-file', newfile)
		},

	}
}
</script>

<style lang='scss' >
.ankaCropper.light {
    background: transparent;
		box-shadow: none
}

.ankaCropper__navButton, .ankaCropper__saveButton {
	height: 36px !important;
	min-width: 32px !important
}

</style>